import * as z from "zod";

/**
 * A date filter in the URL. Values are `yyyy-MM-dd` days, or a
 * `[from, to]` pair under `between` where either end may be open.
 */
export const dateFilterSchema = z.discriminatedUnion("operator", [
  z.object({
    operator: z.literal("is"),
    value: z.string(),
  }),
  z.object({
    operator: z.literal("is_on_or_before"),
    value: z.string(),
  }),
  z.object({
    operator: z.literal("is_on_or_after"),
    value: z.string(),
  }),
  z.object({
    operator: z.literal("between"),
    value: z.tuple([z.string().nullable(), z.string().nullable()]),
  }),
]);

export type DateFilter = z.infer<typeof dateFilterSchema>;
